
import BookingSdnBanner from "@/app/ui/components/booking-sdn-banner/index.vue";
/* eslint-disable @typescript-eslint/camelcase */
import { Vue, Options } from "vue-class-component";
import STTManualReference from "./components/stt-manual-reference/index.vue";
import DetailSender from "./components/detail-sender/index.vue";
import DetailReceiver from "./components/detail-receiver/index.vue";
import Commodity from "./components/comodity/index.vue";
import DeliveryService from "./components/delivery-service/index.vue";
import DetailKoli from "./components/detail-koli/index.vue";
import InsuranceBanner from "./components/banner-product-type/index.vue";
import DocInternational from "./components/booking-extra/doc-international/index.vue";
import DeliveryType from "./components/delivery-type/product/index.vue";
import Footer from "./components/footer/index.vue";
import { ApiRequestList } from "@/domain/entities/MainApp";
import {
  ErrorBookingV3,
  BookingV3,
  FraudStatus,
  PosterProduct,
  SuccessBooking,
  STT,
  DocInternationalModelValueType
} from "@/domain/entities/CreateBookingV3";
import {
  EstimationPrice,
  PayloadPosterProduct,
  ComodityProductPoster,
  PiecesPosterProduct,
  PrintDataEntitas,
  InsuranceTypeDeliveryData
} from "@/domain/entities/Booking";
import { LocationController } from "@/app/ui/controllers/LocationController";
import { BookingController } from "@/app/ui/controllers/BookingController";
import { FlagsPermissionBooking } from "@/feature-flags/flag-booking";
import {
  SubmitPosterProductApiRequest,
  GetEstimationPrice,
  CreateBookingV3Corporate,
  CreateBookingV3Retail,
  PrintDetailRequest
} from "@/data/payload/api/BookingRequest";
import { CountryData, DistrictData } from "@/domain/entities/Location";
import DialogPayment from "@/app/ui/components/dialog-payment/index.vue";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { FlagsMedusa } from "@/feature-flags/flags-misc-medusa";
import { CodConfigurationController } from "@/app/ui/controllers/CodConfigurationController";
import { CodInternationalCountry, DetailCodConfigurationRetail } from "@/domain/entities/CodConfiguration";
import { HeavyWeightSurchargeController } from "@/app/ui/controllers/HeavyWeightSurchargeController";
import { ProductController } from "@/app/ui/controllers/ProductController";
import { ProductConfigurationRuleRequestParams } from "@/data/payload/api/ProductApiRequest";
import { ProductConfigurationRule } from "@/domain/entities/Product";
import {
  HeavyWeightSurchargeData,
  HeavyWeightSurchargeDetailMinimum
} from "@/domain/entities/HeavyWeightSurcharge";
import { PromoConfigurationController } from "@/app/ui/controllers/PromoConfigurationController";
import { PromoConfigurationListRequest } from "@/data/payload/api/PromoConfigurationApiRequest";
import { debounce } from "lodash";
import { nextTick } from "vue";
import { InsuranceController } from "@/app/ui/controllers/InsuranceController";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { RequestInternationalDocumentDetail } from "@/domain/entities/InternationalDocument";
import { InternationalDocumentController } from "@/app/ui/controllers/InternationalDocumentController";
import { parseZodError, parseMultiFieldZodError } from "./utils";
import {
  sttReferenceSchema,
  noSttSchema
} from "./components/stt-manual-reference/validationSttManualReference";
import {
  senderSchema,
  senderPhoneSchema,
  senderAddressSchema,
  senderReceiverSchema
} from "./components/detail-sender/validation";
import {
  receiverSchema,
  receiverPhoneSchema,
  receiverAddressSchema,
  receiverDestinationCitySchema,
  receiverPostalCodeSchema
} from "./components/detail-receiver/validation";
import { commoditySchema } from "./components/comodity/validation-commodity";
import ModalSuccessBooking from "./components/modal-booking/modal-success.vue";
import ModalFailedBooking from "./components/modal-booking/modal-failed.vue";
import {
  downloadFilePrn,
  payloadOfThermalData
} from "@/app/infrastructures/misc/UtilsThermal";
import { ThermalReceiptData } from "@/domain/entities/Printer";
import generateCommercialInvoiceV2 from "@/app/ui/modules/commercial-invoice-v2";
import JsBarcode from "jsbarcode";
import generatePDFV2 from "@/app/ui/modules/receipt-v2/document";
import generateThermalPDFV2 from "@/app/ui/modules/receipt-v2/thermal";
import { logoBlack } from "@/app/ui/modules/receipt-v2/constants/images";
import {
  emailSchema,
  idNumberSchema,
  taxNumberSchema,
  imageSchema,
  itemDetailSchema,
  quantitySchema,
  goodsPriceSchema
} from "./components/booking-extra/doc-international/validation";
import {
  totalGrossWeightSchema,
  totalVolumeWeightSchema
} from "./components/detail-koli/weight-koli/validation";
import {
  estimationPriceSchema,
  getMinMaxGoodsPriceFromFlag
} from "./components/detail-koli/product-price-insurance/validation";
import { Insurance } from "@/domain/entities/Insurance";
import FilterClient from "./components/filter-client/index.vue";
import { clientScheme } from "./components/filter-client/validation";
import { DetailClientManagement } from "@/domain/entities/ClientManagement";
import { AccountEntities } from "@/domain/entities/Account";
import { FlagsPermissionBookingV3 } from "@/feature-flags/flag-booking-v3";
import { getRoundedChargeableWeightByRules } from "@/app/infrastructures/misc/common-library/v2/getRoundedChargeableWeightByRules";
import { createFocusTrap } from "focus-trap";
import ListHistorySuccessBooking from "./components/modal-booking/list-history-success-booking.vue";
import ModalPreviewInvoice from "./components/modal-booking/modal-preview-invoice.vue";
import ModalSuccessReceipt from "../../print-receipt-v2/components/modal-success-receipt.vue";
import { PrintReceiptController } from "@/app/ui/controllers/PrintReceiptController";
import InvoicePdfStruk from "../../print-receipt-v2/components/invoice/InvoicePdfStruk.vue";
import InvoicePdfA4 from "../../print-receipt-v2/components/invoice/InvoicePdfA4.vue";
import { formatByCountry, parsingErrorResponse } from "@/app/infrastructures/misc/Utils";
import { Invoice, PRINT_RECEIPT_KEY } from "@/domain/entities/PrintReceipt";
import { ActivityRequest } from '@/data/payload/api/PrintReceiptApiRequest';
import { resolveDefaultProductName } from "./utils/resolveDefaultProductName";
import { parseByCountry } from "@/app/infrastructures/misc/common-library/FormatInputByCountry";
import { getToken } from "@/app/infrastructures/misc/Cookies";
import { ClientNamePOSData } from "@/domain/entities/Partner";
import { getCurrencyCodeByCountry } from "@/app/infrastructures/misc/common-library/modules/Price";

@Options({
  components: {
    BookingSdnBanner,
    STTManualReference,
    DetailSender,
    DetailReceiver,
    Commodity,
    DeliveryService,
    DetailKoli,
    InsuranceBanner,
    DocInternational,
    DeliveryType,
    Footer,
    DialogPayment,
    ModalSuccessBooking,
    ModalFailedBooking,
    FilterClient,
    ListHistorySuccessBooking,
    ModalPreviewInvoice,
    ModalSuccessReceipt,
    InvoicePdfA4,
    InvoicePdfStruk
  },
  watch: {
    form: {
      handler() {
        this.getInsuranceConfig();
      },
      deep: true
    },
    originCountry() {
      this.getInsuranceAvailability();
    },
    interpackVendorConfigContextSignature: {
      handler() {
        this.fetchInterpackLaneEligibilityDebounced();
      },
      deep: true
    },
    shouldTrimInterpackPieces(shouldTrim: boolean) {
      if (shouldTrim) {
        this.form.pieces = [this.form.pieces[0]];
      }
    },
    "form.serviceType"(newValue: string, oldValue: string) {
      this.form.isCOD =
        newValue === "cod" || newValue === "dfod";
      this.form.isDFOD = newValue === "dfod";

      this.onChangePaymentMethod(newValue, oldValue);
    },
    upsellingData: {
      handler(products: PosterProduct[]) {
        if (!this.form.productName) return;
        if (!products.length) return;
        const isSelectedProductDisabled =
          products.findIndex(
            (product) =>
              product.productType.toLowerCase() ===
              this.form.productName.toLowerCase()
          ) === -1;
        if (isSelectedProductDisabled) this.form.productName = "";
      },
      deep: true
    },
    upsellingPayload: {
      handler() {
        this.getUpsellingDataDebounced();
      },
      deep: true
    },
    estimationPricePayload: {
      handler() {
        this.getEstimationPriceDebounced();
      },
      deep: true
    },
    promoConfigPayload: {
      handler() {
        this.getPromoConfig();
      },
      deep: true
    },
    eligibleAdditionalInfo(val = false) {
      if (!val) {
        this.form.docInternationalForm = new DocInternationalModelValueType();
      } else if (!this.form.docInternationalForm.dutyTaxTerms) {
        this.form.docInternationalForm.dutyTaxTerms = "DAP";
      }
    },
    isFtzAccount(val = false) {
      if (!val) this.form.ftzForm = new DocInternationalModelValueType();
    },
    "form.productName"(productNameValue: string) {
      if (productNameValue) {
        this.tempProductName = productNameValue;
      }
    }
  }
})
class CreateBookingClient extends Vue {
  currentIndex = 0;
  insuranceType = "insurance-client";
  paymentMethod = "";
  form = new BookingV3();

  error = new ErrorBookingV3();
  errorFtz = new ErrorBookingV3();
  errorDocInternational = new ErrorBookingV3();
  isRebookingFlow = false;

  get listProducts() {
    let clientProduct: string[] = this.accountCountryCode === 'MY' ? FlagsPermissionBookingV3.config_upselling_product_list.getValue()
      .countries.MY.client :
    FlagsPermissionBookingV3.config_upselling_product_list.getValue()
      .client;

    if (!FlagsPermissionBooking.config_show_bigpack_fast.isEnabled()) {
      clientProduct = clientProduct.filter(
        (product) => product !== "BIGPACKFAST"
      );
    }

    return clientProduct;
  }

  upsellingData: any[] = [];
  loadingUpsellingData = false;
  isErrorUpselling = false;
  fetchPromisesAfterGetUpselling: string[] = [];

  ccoCodProducts = "";
  ccoCodActive = new DetailCodConfigurationRetail();
  ccoDfodProducts = "";
  ccoDfodActive = new DetailCodConfigurationRetail();
  configurationRules: ProductConfigurationRule[] = [];
  heavyWeightSurchargeConfig = new HeavyWeightSurchargeData();
  heavyWeightSurchargeConfigBigpack = new HeavyWeightSurchargeData();
  heavyWeightSurchargeMinimumConfig = new HeavyWeightSurchargeDetailMinimum();
  estimationPriceData = new EstimationPrice();
  loadingEstimationPrice = false;
  errorEstimationPrice = false;
  internationalDocumentDetailData = new RequestInternationalDocumentDetail();
  insuranceData = new Insurance();

  isShowModalSuccessBooking = false;
  isShowModalFailedBooking = false;
  modalSuccessBookingData = new SuccessBooking();
  modalFailedBookingData = {
    error: "",
    balance: 0,
    price: 0
  };
  bookingType = "";
  showWarningHws = false;
  isErrorSttReference = false;
  isErrorSttManual = false;
  isErrorShipmentId = false;
  clientManagementDetail = new DetailClientManagement();
  tempProductName = "";
  errorRouteNotFound = false;
  loadingValidateShipmentId = false;
  focusTrap: any = null;
  configCodInternationalClient = new DetailCodConfigurationRetail();

  created() {
    window.addEventListener("keydown", this.onEnterBooking);
  }

  async mounted() {
    this.getCODConfig();
    this.getInsuranceAvailability();
    this.getHWSConfig();
    this.getRoundingRulesConfig();
    if (["client"].includes(AccountController.accountData.account_type)) {
      const resp = ((await AccountController.checkAccountLocation()) as any) as AccountEntities;
      this.form.clientName.isFtz =
        resp.account_location.city_free_trade_zone === "yes";
      this.form.clientName.id =
        AccountController.accountData.account_type_detail.id;
      this.form.clientName.clientCode =
        AccountController.accountData.account_type_detail.code;
      ProductController.fetchVolumetricDivisors(resp.account_location.country_code);
    }
    this.getCountryList();

    await nextTick();
    setTimeout(() => {
      this.focusToFilterClient();
    }, 1000);
  }

  unmounted() {
    window.removeEventListener("keydown", this.onEnterBooking);
    if (this.focusTrap) {
      this.focusTrap.deactivate();
      this.focusTrap = null;
    }
    this.clearSessionStorage();
  }

  get maxPieces() {
    if (this.form.isVendorNinjaDestination) return 1;
    if (this.isInterpack) {
      return this.interpackLaneEligible ? 15 : 1;
    }
    return 15;
  }

  // --- Multi-koli INTERPACK lane eligibility (GENESIS-20516) ---
  get isInterpack(): boolean {
    return ["INTERPACK", "INTERPACKMAXI"].includes(
      this.form.productName.toUpperCase()
    );
  }

  get isMyPlatform(): boolean {
    return this.originCountry.toUpperCase() === "MY";
  }

  // Non-MY origin INTERPACK/INTERPACKMAXI stays capped at 1 koli (unchanged
  // pre-ticket behavior); only MY-origin lanes resolve real eligibility.
  get interpackLaneEligible(): boolean {
    if (!this.isInterpack) return true;
    if (!this.isMyPlatform) return false;
    return ProductController.interpackLaneMultiplePieces;
  }

  // Level-based (not edge on interpackLaneEligible) so trimming re-evaluates
  // on any origin/product/lane/resolving change. MY-origin skips while the
  // lane is resolving (fail-closed `false` is transient).
  get shouldTrimInterpackPieces(): boolean {
    if (this.form.pieces.length <= 1 || this.interpackLaneEligible) return false;
    if (this.isMyPlatform) {
      return this.canResolveInterpackLane && !this.isInterpackLanePending;
    }
    return true;
  }

  // Signature of the last completed lane resolve. Until it matches the current
  // context (debounce window + in-flight request), the stale/fail-closed
  // `interpackLaneMultiplePieces` must not be used to trim koli.
  resolvedInterpackLaneSignature = "";

  get canResolveInterpackLane(): boolean {
    return (
      this.isInterpack &&
      this.isMyPlatform &&
      !!this.destinationCity.countryCode &&
      !!this.form.commodity.code
    );
  }

  get isInterpackLanePending(): boolean {
    if (!this.canResolveInterpackLane) return false;
    return (
      ProductController.interpackLaneResolving ||
      this.resolvedInterpackLaneSignature !==
        this.interpackVendorConfigContextSignature
    );
  }

  get interpackVendorConfigContextSignature() {
    return JSON.stringify({
      isInterpack: this.isInterpack,
      isMyPlatform: this.isMyPlatform,
      destinationCountryCode: this.destinationCity.countryCode,
      commodityCode: this.form.commodity.code
    });
  }

  fetchInterpackLaneEligibilityDebounced = debounce(async () => {
    if (!this.canResolveInterpackLane) return;
    const commodityCode = this.form.commodity.code;
    if (!commodityCode) return;
    const signature = this.interpackVendorConfigContextSignature;
    await ProductController.fetchInterpackLaneMultiplePieces({
      originCountryCode: this.originCountry,
      destinationCountryCode: this.destinationCity.countryCode,
      commodityCode
    });
    this.resolvedInterpackLaneSignature = signature;
  }, 500);

  get districtDetail() {
    return LocationController.districtDetail;
  }

  get destinationCity(): DistrictData {
    if (typeof this.form.destinationCity === "string") {
      return new DistrictData();
    }
    return this.form.destinationCity;
  }

  get postalCodeDestination() {
    return this.form.postalCodeDestination instanceof DistrictData
      ? this.form.postalCodeDestination
      : new DistrictData();
  }

  get originCityCode() {
    return this.districtDetail.cityCode;
  }

  get accountIsNonForeign() {
    return !AccountController.accountData.accountIsForeign;
  }

  get accountCountryCode() {
    return AccountController.accountData.countryCode?.toUpperCase();
  }

  get isFtzAccount() {
    return ["client"].includes(AccountController.accountData.account_type)
      ? this.form.clientName.isFtz
      : ["internal", "partner"].includes(
          AccountController.accountData.account_type
        )
      ? this.form.clientName.isFtz
      : AccountController.accountData.account_location?.city_free_trade_zone ===
          "yes" && this.accountIsNonForeign;
  }

  get isInterpackAdditionalInfo() {
    return FlagsMedusa.flag_release_interpack_additional_info.isEnabled();
  }

  get destinationCountryCode() {
    return (this.destinationCity.countryCode || "").trim().toUpperCase();
  }

  get isInternationalBooking() {
    if (
      !this.destinationCity.id ||
      !this.originCountryCode ||
      !this.destinationCountryCode
    ) {
      return false;
    }
    const productType = (this.form.productName || "").trim().toUpperCase();
    return (
      this.originCountryCode !== this.destinationCountryCode ||
      ["INTERPACK", "INTERPACKMAXI"].includes(productType)
    );
  }

  get eligibleAdditionalInfo() {
    return this.isInterpackAdditionalInfo && this.isInternationalBooking;
  }

  get isBlacklist() {
    return BookingController.phoneCheckerData.isBlacklist;
  }

  get isLimited() {
    return (
      BookingController.phoneCheckerData.status === FraudStatus.LIMITED &&
      FlagsPermissionBooking.disable_cod_dfod_for_limited_number.isEnabled()
    );
  }

  get isDocInternationalFormValid() {
    const validation = {
      isEmailValid: !parseZodError(
        emailSchema(
          this.internationalDocumentDetailData.email,
          false,
          this.form.docInternationalForm.email
        ),
        this.form.docInternationalForm.email
      ),
      isIdentityNumberValid: !parseZodError(
        idNumberSchema(
          this.internationalDocumentDetailData.idcIsIdentityNumber
        ),
        this.form.docInternationalForm.idNumber
      ),
      isTaxNumberValid: !parseZodError(
        taxNumberSchema(
          this.internationalDocumentDetailData.idcIsTaxIdentificationNumber,
          false,
          this.form.docInternationalForm.taxNumber,
          100,
          1
        ),
        this.form.docInternationalForm.taxNumber
      ),
      isIdentityImageValid: !parseZodError(
        imageSchema(
          this.internationalDocumentDetailData.ktp,
          this.form.docInternationalForm.imageIdUrl
        ),
        this.form.docInternationalForm.imageIdUrl
      ),
      isTaxImageValid: !parseZodError(
        imageSchema(
          this.internationalDocumentDetailData.npwp,
          this.form.docInternationalForm.imageTaxUrl
        ),
        this.form.docInternationalForm.imageTaxUrl
      ),
      isBeforePackingImageValid: !parseZodError(
        imageSchema(
          this.internationalDocumentDetailData.afterPacking,
          this.form.docInternationalForm.imageBeforePackingUrl
        ),
        this.form.docInternationalForm.imageBeforePackingUrl
      ),
      isAfterPackingImageValid: !parseZodError(
        imageSchema(
          this.internationalDocumentDetailData.afterPacking,
          this.form.docInternationalForm.imageAfterPackingUrl
        ),
        this.form.docInternationalForm.imageAfterPackingUrl
      ),
      isCIPLValid: this.validateCIPL(),
      isDutyTaxTermsValid: ["DAP", "DDP"].includes(
        this.form.docInternationalForm.dutyTaxTerms
      )
    };

    return !Object.values(validation).includes(false);
  }

  get isFtzFormValid() {
    const validation = {
      isEmailValid: !parseZodError(
        emailSchema(false, true, this.form.ftzForm.email),
        this.form.ftzForm.email
      ),
      isIdentityNumberValid: !parseZodError(
        idNumberSchema(false),
        this.form.ftzForm.idNumber
      ),
      isTaxNumberValid: !parseZodError(
        taxNumberSchema(false, true, this.form.ftzForm.taxNumber),
        this.form.ftzForm.taxNumber
      ),
      isIdentityImageValid: !parseZodError(
        imageSchema(false, this.form.ftzForm.imageIdUrl),
        this.form.ftzForm.imageIdUrl
      ),
      isTaxImageValid: !parseZodError(
        imageSchema(false, this.form.ftzForm.imageTaxUrl),
        this.form.ftzForm.imageTaxUrl
      ),
      isBeforePackingImageValid: !parseZodError(
        imageSchema(false, this.form.ftzForm.imageBeforePackingUrl),
        this.form.ftzForm.imageBeforePackingUrl
      ),
      isAfterPackingImageValid: !parseZodError(
        imageSchema(false, this.form.ftzForm.imageAfterPackingUrl),
        this.form.ftzForm.imageAfterPackingUrl
      ),
      isCIPLValid: this.validateCIPL(true)
    };

    return !Object.values(validation).includes(false);
  }

  get isFormValid() {
    const formValidation = {
      ...this.validateClientAndReference(),
      ...this.validateSender(),
      ...this.validateRecipient(),
      ...this.validateCommodityAndService(),
      ...this.validateWeight(),
      ...this.validateOthers()
    };
    return !Object.values(formValidation).includes(false);
  }

  validateClientAndReference() {
    return {
      isClientValid: this.flagEnableHandleSelectClientIdFromShipment
        ? true
        : this.isAccountPosOrInternal
          ? !parseZodError(clientScheme, this.form.clientName.clientName)
          : true,
      isSttReferenceValid: this.form.referenceExternal
        ? !parseZodError(sttReferenceSchema, this.form.referenceExternal)
        : true,
      isSttManualValid: this.form.sttManual
        ? !parseZodError(noSttSchema, this.form.sttManual)
        : true,
      isClientDOValid: !this.isDO
        ? true
        : !parseZodError(sttReferenceSchema, this.form.referenceExternal),
      isSttReferenceAvailable: !this.isErrorSttReference,
      isSttManualAvailable: !this.isErrorSttManual,
      isShipmentIdValid: !this.isErrorShipmentId,
      isShipmentNotValidating: !this.loadingValidateShipmentId
    };
  }

  validateSender() {
    return {
      isSenderNameValid: !parseZodError(senderSchema, this.form.sender),
      isSenderPhoneValid: !parseZodError(
        senderPhoneSchema,
        (this.form.phoneCodeSender + this.form.phoneSender).replace("+", "")
      ),
      isSenderAddressValid: !parseZodError(
        senderAddressSchema,
        this.form.addressSender
      ),
      isSenderRecipientAddressValid: !parseMultiFieldZodError(
        senderReceiverSchema,
        {
          addressSender: this.form.addressSender,
          addressReceiver: this.form.addressReceiver
        },
        "addressSender"
      )
    };
  }

  validateRecipient() {
    return {
      isRecipientNameValid: !parseZodError(receiverSchema, this.form.receiver),
      isRecipientPhoneValid: !parseZodError(
        receiverPhoneSchema,
        (this.form.phoneCodeReceiver + this.form.phoneReceiver).replace("+", "")
      ),
      isRecipientAddressValid: !parseZodError(
        receiverAddressSchema,
        this.form.addressReceiver
      ),
      isRecipientDestinationValid: !parseZodError(
        receiverDestinationCitySchema,
        {
          destination: this.destinationCity.name,
          embargo: this.form.destinationIsEmbargo,
          unavailable: this.form.destinationIsUnavailable
        }
      ),
      isRecipientPostalCodeValid: !parseZodError(
        receiverPostalCodeSchema,
        this.postalCodeDestination.name
      )
    };
  }

  validateCommodityAndService() {
    return {
      isCommodityValid: !parseZodError(commoditySchema, this.form.commodity),
      isServiceTypeValid: !!this.form.serviceType,
      isProductNameValid: !!this.form.productName
    };
  }

  validateWeight() {
    return {
      isTotalGrossWeightValid: this.form.pieces.every((piece: any) => Number(piece.grossWeight.replace(",", ".")) > 0) && !parseZodError(totalGrossWeightSchema, this.form.pieces.reduce((sum: number, piece: any) => sum + Number(piece.grossWeight.replace(",", ".")), 0)),
      isTotalVolumeWeightValid: this.form.pieces.every((piece: any) => Number(piece.volumeWeight) > 0) && !parseZodError(totalVolumeWeightSchema, this.form.pieces.reduce((sum: number, piece: any) => sum + Number(piece.volumeWeight), 0)),
      isHWSValid: !(
        this.form.pieces
          .map(
            (piece: any) =>
              this.parseNumber(piece.grossWeight) >=
              this.heavyWeightSurchargeMinimumConfigData.heavyWeightMinimum
          )
          .some((pre) => pre) &&
        this.heavyWeightSurchargeMinimumConfigData.minimumExist &&
        this.form.pieces.length > 1
      )
    };
  }

  get minMaxConfig() {
    return getMinMaxGoodsPriceFromFlag("client");
  }

  get codConfigByDestination() {
    return new CodInternationalCountry(
      this.configCodInternationalClient.countries.find(
        (c) => c.countryCode === this.form.destinationCountry.code
      )
    );
  }

  validateOthers() {
    const price = this.parseNumber(this.form.estimationPrice);
    let min = 0;
    let max = 0;

    if (this.isCrossCountryCod) {
      const { minPrice, maxPrice } = this.codConfigByDestination;

      min = Number(minPrice);
      max = Number(maxPrice);
    } else {
      const { min: minPrice, max: maxPrice } = this.minMaxConfig;

      min = minPrice;
      max = maxPrice;
    }

    return {
      isDocInternationalValid: this.eligibleAdditionalInfo
        ? this.isDocInternationalFormValid
        : true,
      isFtzValid: this.isFtzAccount ? this.isFtzFormValid : true,
      isEstimationPriceValid: !parseZodError(estimationPriceSchema, {
        estimationPrice: String(price),
        minEstimationPrice: min,
        maxEstimationPrice: max,
        productName: this.form.productName,
        listCodActive: this.ccoCodActive,
        listDfodActive: this.ccoDfodActive,
        deliveryFeeType: this.deliveryFeeType,
        isFormBookClient: true
      }),
      isMaxKoliValid: !(this.form.pieces.length > this.maxPieces),
      isNotEmbargo: !this.isErrorEmbargoDestination
    };
  }

  get deliveryFeeType() {
    if (this.form.isCOD && this.form.isDFOD) return "dfod";
    if (this.form.isCOD) return "cod";
    return "non-cod";
  }

  parseNumber(value: string): number {
    return parseByCountry(value, {
      country: this.isCrossCountryCod
        ? this.form.destinationCountry.code
        : this.accountCountryCode
    });
  }

  get goodsPrice(): number {
    return this.parseNumber(this.form.estimationPrice || "0");
  }

  get upsellingPayload() {
    return new SubmitPosterProductApiRequest({
      payload: new PayloadPosterProduct({
        originId: this.districtDetail.code as any,
        destinationId: this.destinationCity.code,
        commodity:
          typeof this.form.commodity === "object"
            ? {
                data: new ComodityProductPoster({
                  commodityId: +(this.form.commodity.id as number),
                  commodityName: this.form.commodity?.name,
                  commodityCode: this.form.commodity?.code
                })
              }
            : { data: new ComodityProductPoster() },
        commodityId:
          typeof this.form.commodity === "object"
            ? (this.form.commodity.id as number)
            : 499,
        isCod: ["cod", "dfod"].includes(this.form.serviceType),
        isDfod: this.form.serviceType === "dfod",
        codAmount: Math.max(
          ["cod", "dfod"].includes(this.form.serviceType) ? 1 : 0,
          Number(
            this.form.codAmount
              ? this.parseNumber(this.form.codAmount)
              : this.goodsPrice
          )
        ),
        goodsPrice: this.goodsPrice,
        pieces: this.form.pieces.map(
          (piece: any) =>
            new PiecesPosterProduct({
              pieceWidth: piece.dimension.width,
              pieceLength: piece.dimension.length,
              pieceHeight: piece.dimension.height,
              pieceGrossWeight: this.parseNumber(piece.grossWeight)
            })
        ),
        accountType: this.clientlientIdForProductUpselling.accountType,
        accountRefId: this.clientlientIdForProductUpselling.accountRefId,
        isBookingPuposes: false,
        insuranceType: this.form.insurance,
        isWoodpacking: this.form.woodpacking
      })
    });
  }

  get codAmount() {
    const codAmount = this.form.codAmount;
    if (typeof codAmount === "number") return codAmount;
    return this.parseNumber(this.form.codAmount)
  }

  get estimationPricePayload() {
    return new GetEstimationPrice({
      originId: this.districtDetail.code,
      destinationId: this.destinationCity.code,
      commodityId: this.form.commodity.id,
      productType: this.form.productName,
      accountType: this.clientlientIdForProductUpselling.accountType,
      accountRefId: this.clientlientIdForProductUpselling.accountRefId,
      goodsPrice: this.parseNumber(this.form.estimationPrice),
      insuranceType: this.form.insurance,
      isWoodpacking: this.form.woodpacking,
      isHaveTaxId: !!this.form.ftzForm.taxNumber,
      pieces: this.form.pieces.map((piece: any) => ({
        pieceLength: piece.dimension.length,
        pieceWidth: piece.dimension.width,
        pieceHeight: piece.dimension.height,
        pieceGrossWeight: this.parseNumber(piece.grossWeight)
      })) as any,
      isCod:
        this.form.serviceType === "cod" || this.form.serviceType === "dfod",
      isDfod: this.form.serviceType === "dfod",
      codHandling: "",
      codAmount: this.codAmount,
      isDisablePromo: false,
      promoAppliedTo: "retail",
      isPad: false,
      shipmentPrefix: "",
      hideError: false,
      discountFavoritePercentage: 0
    });
  }

  get promoConfigPayload() {
    return new PromoConfigurationListRequest({
      page: 1,
      limit: 2,
      origin: this.districtDetail.cityCode,
      destination: this.destinationCity.cityCode,
      productName: this.form.productName,
      status: "active,nearly-expired",
      grossWeight: this.totalGrossWeight,
      volumeWeight: this.totalVolumeWeight,
      chargeableWeight: this.chargeableWeight,
      appliedTo: "retail"
    });
  }

  get insurancePayload() {
    return new ApiRequestList({
      isPagination: true,
      typeInsurance: this.form.insurance,
      goodsPrice: this.parseNumber(this.form.estimationPrice),
      country: AccountController.accountData.countryCode,
      accountType: this.clientlientIdForProductUpselling.accountType,
      accountRefId: this.clientlientIdForProductUpselling.accountRefId
    });
  }

  get isCODDisabled() {
    // catatan: tidak perlu disable cod by config
    // if (this.ccoCodActive.ccoStatus !== "active") return true;
    if (this.isCrossCountryRoute) {
      return !this.configCodInternationalClient.ccoProductType
        .split(",")
        .some((item) => item === this.form.productName);
    }
    return false;
  }

  get isDFODDisabled() {
    // catatan: tidak perlu disable dfod by config
    // if (this.ccoDfodActive.ccoStatus !== "active") return true;
    // return !this.ccoDfodProducts.includes(this.form.productName);
    return false;
  }

  get totalGrossWeight() {
    const total = this.form.pieces.reduce(
      (prev, curr: any) => prev + this.parseNumber(curr.grossWeight),
      0
    );
    return parseFloat(total.toFixed(2));
  }

  get totalVolumeWeight() {
    const total = this.form.pieces.reduce(
      (prev, curr: any) =>
        prev + this.parseNumber(curr.convertVolumeWeight),
      0
    );
    return parseFloat(total.toFixed(2));
  }

  get chargeableWeight() {
    const chWeight = Math.max(this.totalGrossWeight, this.totalVolumeWeight);
    const currentRule = this.configurationRules.find(
      (rule) =>
        rule.product.toLowerCase() === this.form.productName.toLowerCase()
    );
    if (!this.form.productName) {
      return getRoundedChargeableWeightByRules({
        productType: "",
        rule: 0.31,
        chargeableWeight: chWeight,
        ruleKey: currentRule?.ruleKey
      });
    }

    return getRoundedChargeableWeightByRules({
      chargeableWeight: chWeight,
      productType: this.form.productName.toUpperCase(),
      rule: Number(currentRule?.parameter),
      ruleKey: currentRule?.ruleKey
    });
  }

  get payload() {
    return {
      ...this.getBasicInfo(),
      ...this.getWeights(),
      ...this.getContactInfo(),
      ...this.getDocuments(),
      ...this.getPieces(),
      ...this.getFTZCipl(),
      ...this.getCipl(),
      isNewForm: true,
      statusGoods: this.form.ftzForm.shipmentStatus.value || "ecommerce",
      isPAD: false,
      saveCustomerSender: this.form.isSaveSender,
      saveCustomerRecipient: this.form.isSaveReceiver,
      sttInterTaxNumber: this.form.docInternationalForm.taxNumber,
      sttDutyTaxTerms: this.form.docInternationalForm.dutyTaxTerms,
      sttCodAmount:
        (!this.isCodAmount || !this.codAmount) && this.form.isCOD
          ? this.parseNumber(this.form.estimationPrice)
          : this.codAmount,
      sttShipmentId:
        !this.isErrorShipmentId &&
        this.form.shipmentId &&
        this.form.shipmentId.length > 3
          ? this.form.shipmentId
          : ""
    };
  }

  getBasicInfo() {
    let sttClient = 0;
    sttClient = this.isAccountClient ? this.clientId : this.form.clientName.id;
    if (
      this.flagEnableHandleSelectClientIdFromShipment &&
      sttClient === 0 &&
      this.isSuccessfulCallFromShipment
    ) {
      sttClient = this.clientIdFromShipment;
    }

    return {
      sttClient: sttClient,
      sttManual: this.form.sttManual,
      referenceExternal: this.form.referenceExternal,
      productName: this.form.productName,
      originCity: this.districtDetail.cityCode,
      destinationCity: this.destinationCity.cityCode,
      originDistrict: this.districtDetail.code,
      destinationDistrict: this.destinationCity.code,
      insurance: this.form.insurance,
      commodityCode: this.form.commodity.code,
      isCOD: ["dfod", "cod"].includes(this.form.serviceType),
      isDFOD: this.form.serviceType === "dfod",
      estimationPrice: this.parseNumber(this.form.estimationPrice)
    };
  }

  getWeights() {
    return {
      sttGrossWeight: this.totalGrossWeight,
      sttVolumeWeight: this.totalVolumeWeight,
      sttChargeableWeight: this.estimationPriceData.chargeableWeight
      // sttChargeableWeight: this.chargeableWeight
    };
  }

  getContactInfo() {
    return {
      phoneSender: this.form.phoneCodeSender + this.form.phoneSender,
      phoneReceiver: this.form.phoneCodeReceiver + this.form.phoneReceiver,
      sender: this.form.sender,
      receiver: this.form.receiver,
      addressSender: this.form.addressSender,
      addressReceiver: this.form.addressReceiver,
      addressReceiverType: this.form.addressReceiverType.value,
      isWoodpack: this.form.woodpacking,
      isSaveSender: this.form.isSaveSender,
      isSaveReceiver: this.form.isSaveReceiver,
      postalCodeDestination: this.postalCodeDestination.name
    };
  }

  getDocuments() {
    return {
      sttAttachFiles: [
        this.form.docInternationalForm.imageBeforePackingUrl,
        this.form.docInternationalForm.imageAfterPackingUrl
      ].filter(Boolean),
      sttRecipientEmail: this.form.docInternationalForm.email,
      sttKtpImage: this.form.docInternationalForm.imageIdUrl,
      sttTaxImage: this.form.docInternationalForm.imageTaxUrl,
      sttIdentityNumber: this.form.docInternationalForm.idNumber,
      sttCodAmount: this.parseNumber(this.form.estimationPrice)
    };
  }

  getPieces() {
    return {
      sttPieces: this.form.pieces.map((key: any) => ({
        stt_piece_length: key.dimension.length,
        stt_piece_width: key.dimension.width,
        stt_piece_height: key.dimension.height,
        stt_piece_gross_weight: this.parseNumber(key.grossWeight),
        stt_piece_volume_weight: this.parseNumber(key.volumeWeight)
      }))
    };
  }

  getFTZCipl() {
    return {
      sttFtzKtpImage: this.form.ftzForm.imageIdUrl,
      sttFtzAttachFiles: [
        this.form.ftzForm.imageBeforePackingUrl,
        this.form.ftzForm.imageAfterPackingUrl
      ].filter(Boolean),
      sttFtzRecipientEmail: this.form.ftzForm.email,
      sttFtzIdentityNumber: this.form.ftzForm.idNumber,
      sttFtzTaxImage: this.form.ftzForm.imageTaxUrl,
      sttFtzCipl: this.form.ftzForm.listCommodityCIPL
        .filter((cipl) => cipl.name)
        .map((cipl: any) => ({
          quantity: parseByCountry(cipl.quantity.toString(), { country: this.accountCountryCode }),
          itemPrice: parseByCountry(cipl.goodsPrice.toString(), { country: this.accountCountryCode }),
          itemDetailEn: cipl.commodity.nameEn || cipl.name,
          itemDetail: cipl.commodity.nameId || cipl.name,
          commodityHsCode: cipl.commodity.hsCode,
        })),
      sttTaxNumber: this.form.ftzForm.taxNumber,
      taxNumber: this.form.ftzForm.taxNumber
    };
  }

  getCipl() {
    return {
      sttCipl: this.form.docInternationalForm.listCommodityCIPL
        .filter((cipl) => cipl.name)
        .map((cipl: any) => ({
          quantity: parseByCountry(cipl.quantity.toString(), { country: this.accountCountryCode }),
          itemPrice: parseByCountry(cipl.goodsPrice.toString(), { country: this.accountCountryCode }),
          itemDetailEn: cipl.commodity.nameEn || cipl.name,
          itemDetail: cipl.commodity.nameId || cipl.name,
          commodityHsCode: cipl.commodity.hsCode,
        }))
    };
  }

  get heavyWeightSurchargeMinimumConfigData() {
    const productName = this.form.productName || this.tempProductName;
    if (
      !this.heavyWeightSurchargeConfig.configurableHeavyWeight ||
      !this.heavyWeightSurchargeConfigBigpack.configurableHeavyWeight
    )
      return new HeavyWeightSurchargeDetailMinimum();
    const isActive =
      this.heavyWeightSurchargeConfig.configurablePriceStatus.toLowerCase() ||
      this.heavyWeightSurchargeConfigBigpack.configurablePriceStatus.toLowerCase() ===
        "active";
    const product = this.heavyWeightSurchargeConfig.configurableHeavyWeight.heavy_weight_surcharge_product_include.product_types.includes(
      productName.toUpperCase()
    );
    const productBigpack = this.heavyWeightSurchargeConfigBigpack.configurableHeavyWeight.heavy_weight_surcharge_product_include.product_types.includes(
      productName.toUpperCase()
    );
    const isEnableHwsConfig = FlagsPermissionBooking.hws_configuration.isEnabled();
    const commodity = this.heavyWeightSurchargeConfig.configurableHeavyWeight.heavy_weight_surcharge_commodity_exclude.commodities.find(
      (item: any) =>
        item.commodity_code === this.form.commodity.code ||
        item.commodity_name === this.form.commodity.name
    );
    const commodityBigpack = this.heavyWeightSurchargeConfigBigpack.configurableHeavyWeight.heavy_weight_surcharge_commodity_exclude.commodities.find(
      (item: any) =>
        item.commodity_code === this.form.commodity.code ||
        item.commodity_name === this.form.commodity.name
    );

    const otherCondition =
      (product || productBigpack) && (!commodity || !commodityBigpack);
    const isSetMinimumHws = isActive && otherCondition && isEnableHwsConfig;
    if (isSetMinimumHws) {
      return new HeavyWeightSurchargeDetailMinimum({
        heavyWeightMinimum: productBigpack
          ? this.heavyWeightSurchargeConfigBigpack.configurableHeavyWeight
              .heavy_weight_surcharge_additional_cost.additional_costs[0]
              ?.weight_min
          : this.heavyWeightSurchargeConfig.configurableHeavyWeight
              .heavy_weight_surcharge_additional_cost.additional_costs[0]
              ?.weight_min,
        minimumExist: true
      });
    }

    return new HeavyWeightSurchargeDetailMinimum();
  }

  validateCIPL(isFtz = false) {
    if (!this.internationalDocumentDetailData.commodity && !isFtz) return true;
    const validations: boolean[] = [];
    const ciplList = isFtz
      ? this.form.ftzForm.listCommodityCIPL
      : this.form.docInternationalForm.listCommodityCIPL;

    ciplList.forEach((cipl) => {
      validations.push(!parseZodError(itemDetailSchema, cipl.name));
      validations.push(!parseZodError(quantitySchema, cipl.quantity));
      validations.push(!parseZodError(goodsPriceSchema, cipl.goodsPrice));
    });

    return !Object.values(validations).includes(false);
  }

  get clientlientIdForProductUpselling() {
    let accountRefId = 0;
    const accountType = "client";

    if (this.isAccountPosOrInternal) {
      accountRefId = this.form.clientName.id;
    } else {
      accountRefId = AccountController.accountData.account_type_detail.id;
    }

    if (
      this.flagEnableHandleSelectClientIdFromShipment &&
      accountRefId === 0 &&
      this.isSuccessfulCallFromShipment
    ) {
      accountRefId = this.clientIdFromShipment;
    }

    return {
      accountRefId,
      accountType
    };
  }

  async getUpsellingData() {
    if (!this.destinationCity.id) return;
    try {
      this.isErrorUpselling = false;
      this.upsellingData = [];
      this.loadingUpsellingData = true;
      this.errorRouteNotFound = false;
      const resp = await BookingController.postToGetPosterProduct(
        this.upsellingPayload
      );
      this.upsellingData = resp.map(
        (product: any) =>
          new PosterProduct({
            productType: product.name,
            estimateSla: product.sla,
            totalTariffAfterDiscount: product.total_tariff_after_discount,
            commissionRate: product.commission_rate,
            bookingCommission: product.booking_commission,
            isEmbargo: product.is_embargo,
            shippingCost: product.shipping_cost
          })
      );
      if (!this.upsellingData.length) return;
      this.form.productName = resolveDefaultProductName(this.listProducts, this.upsellingData, this.form.productName);
      this.fetchPromisesAfterGetUpselling.forEach((fn: any) => {
        this[fn as keyof CreateBookingClient]();
      });
      this.$emit("upselling");
    } catch (err) {
      this.handleErrorUpselling(err);
    } finally {
      this.loadingUpsellingData = false;
    }
  }

  calculationVolumeWeight() {
    try {
      const detailKoli: any = this.$refs.detailKoli;
      const weightKoli: any = detailKoli?.$refs?.weightKoli;
      if (
        weightKoli?.calculationVolumeWeight &&
        Array.isArray(this.form.pieces)
      ) {
        this.form.pieces.forEach((_: any, index: number) => {
          weightKoli.calculationVolumeWeight(index);
        });
      }
    } catch (err) {
      console.log(err, "err");
    }
  }

  handleErrorUpselling(err: any) {
    this.upsellingData = [];
    this.isErrorUpselling = err?.response?.status >= 500;
    this.errorRouteNotFound =
      err?.response?.data?.message?.id ===
      "Harga Shipping Surcharge dan Publish Rate untuk rute yang dipilih tidak tersedia";
    this.form.productName = "";
  }

  getUpsellingDataDebounced = debounce(async function(this: CreateBookingClient) {
    await this.getUpsellingData();
    await nextTick();
    this.calculationVolumeWeight();
  }, 500);

  async getCODConfig() {
    const res = await CodConfigurationController.getList(
      new ApiRequestList({
        page: 1,
        limit: 20,
        status: "active"
      })
    );

    const codConfig = res.data.find((config: DetailCodConfigurationRetail) => {
      return config.ccoName === "COD Retail";
    }) as DetailCodConfigurationRetail;
    const dfodConfig = res.data.find((config: DetailCodConfigurationRetail) => {
      return config.ccoName === "DFOD Retail";
    }) as DetailCodConfigurationRetail;
    const codInternationalClientConfig = new DetailCodConfigurationRetail(
      res.data.find(
        (config: DetailCodConfigurationRetail) =>
          config.ccoName === "COD International Client"
      )
    );

    this.ccoCodActive = codConfig;
    this.ccoDfodActive = dfodConfig;
    this.ccoCodProducts = codConfig.ccoProductType;
    this.ccoDfodProducts = dfodConfig.ccoProductType;
    this.configCodInternationalClient = codInternationalClientConfig;
  }

  getHWSConfig = debounce(async () => {
    try {
      const resp = await HeavyWeightSurchargeController.getDetailHeavyWeightSurcharge(
        { id: 1 }
      );
      const respBigpack = await HeavyWeightSurchargeController.getDetailHeavyWeightSurcharge(
        { id: 2 }
      );
      this.heavyWeightSurchargeConfig = resp;
      this.heavyWeightSurchargeConfigBigpack = respBigpack;
    } catch (err) {
      this.heavyWeightSurchargeMinimumConfig = new HeavyWeightSurchargeDetailMinimum(
        {
          heavyWeightMinimum: 0,
          minimumExist: false
        }
      );
    }
  }, 500);

  async getRoundingRulesConfig() {
    const resp = await ProductController.fetchProductConfigurationRule(
      new ProductConfigurationRuleRequestParams({
        page: 1,
        isNoLimit: true,
        countryCode: ProductController.countryCode
      })
    );
    this.configurationRules = resp.data;
  }

  getPromoConfig = debounce(async () => {
    if (
      !this.destinationCity.id ||
      !this.form.productName ||
      !this.totalGrossWeight ||
      !this.totalGrossWeight
    )
      return;
    const resp = await PromoConfigurationController.getPromoConfigurationList(
      this.promoConfigPayload
    );
  }, 500);

  getInsuranceConfig = debounce(async () => {
    if (!this.form.estimationPrice) return;
    const resp = await InsuranceController.getInsurance(this.insurancePayload);
    this.insuranceData = resp;
  }, 500);

  getInsuranceAvailability = debounce(async () => {
    if (this.accountCountryCode !== "MY") return;

    if (!getToken()) return;
    await BookingController.getInsuranceTypesDelivery({
      insuranceConfig: 2,
      originCountry: this.originCountry
    });
  }, 500);

  get insuranceBasic() {
    const basic = BookingController.insuranceTypeDelivery.data.find(
      (item: InsuranceTypeDeliveryData) => item.value === "basic"
    );

    return new InsuranceTypeDeliveryData(basic);
  }

  get originCountry() {
    return (
      this.districtDetail?.countryCode ??
      AccountController.accountData.countryCode
    );
  }

  async getEstimationPrice() {
    try {
      this.loadingEstimationPrice = true;
      this.errorEstimationPrice = false;
      const resp = (await BookingController.getEstimationPriceForNewBooking(
        this.estimationPricePayload
      )) as EstimationPrice;
      this.estimationPriceData = resp;
    } catch (err) {
      if (err?.response?.status >= 500) {
        this.errorEstimationPrice = true;
      }
    } finally {
      this.loadingEstimationPrice = false;
    }
  }

  getEstimationPriceDebounced = debounce(async () => {
    if (
      [
        !this.destinationCity.id,
        !this.form.commodity.id,
        !this.form.estimationPrice,
        !this.form.productName
      ].includes(true)
    )
      return;
    if (this.loadingUpsellingData)
      return this.fetchPromisesAfterGetUpselling.push(
        "getEstimationPriceDebounced"
      );
    this.getEstimationPrice();
  }, 500);

  async getInternationalDocConfig() {
    if (!this.eligibleAdditionalInfo) return;

    const resp = await InternationalDocumentController.getInternationalDocumentDetail(
      {
        dest: this.destinationCity.cityId,
        origin: this.districtDetail.cityId
      }
    );

    this.internationalDocumentDetailData = resp;
  }

  async onBooking(bookingType: string) {
    this.bookingType = bookingType;
    this.isRebookingFlow = false;
    switch (this.bookingType) {
      case "book-print-later":
        await this.onCreateBooking();
        break;
      case "book-print-thermal":
        await this.bookPrintThermal();
        break;
      case "book-print-thermal-pdf":
        await this.bookPrintDoc(0, true);
        break;
      case "book-print-pdf":
        await this.bookPrintDoc(1);
        break;
      default:
        await this.onCreateBooking();
        break;
    }
  }

  get endpointBooking() {
    return this.isAccountClient
      ? BookingController.addManualBooking(
          new CreateBookingV3Retail(this.payload as any)
        )
      : BookingController.addCorporateBooking(
          new CreateBookingV3Corporate(this.payload as any)
        );
  }

  get isForeignAccount() {
    return AccountController.accountData.accountIsForeign;
  }

  get errorFailedBookingValidation() {
    if (
      this.modalFailedBookingData.error ===
        "Stt tidak bisa dibooking. Mohon cek apakah client atau destinasi yang dipilih memperbolehkan layanan DFOD" ||
      this.modalFailedBookingData.error ===
        "Stt cannot be booked. Please check is client or the destination allowed for DFOD services"
    ) {
      return true;
    }

    return false;
  }

  async onCreateBooking() {
    if (MainAppController.loadingModal) return;
    this.isShowModalSuccessBooking = false;
    this.isShowModalFailedBooking = false;
    this.modalFailedBookingData = {
      error: "",
      balance: 0,
      price: 0
    };
    MainAppController.showLoading();
    try {
      if (
        !this.insuranceBasic.isAvailable &&
        this.accountCountryCode === "MY"
      ) {
        this.form.insurance = "free";
      }

      const resp = await (this.isAccountClient
        ? BookingController.addManualBooking(
            new CreateBookingV3Retail(this.payload as any)
          )
        : BookingController.addCorporateBooking(
            new CreateBookingV3Corporate(this.payload as any)
          ));
      this.isShowModalSuccessBooking = true;
      this.modalSuccessBookingData = new SuccessBooking({
        codAmount: resp.data.cod_amount,
        codFee: resp.data.cod_fee,
        destinationCityName: resp.data.destination_city_name,
        destinationDistrictName: resp.data.destination_district_name,
        estimateSla: resp.data.estimate_sla,
        estimationDate: resp.data.estimation_date,
        isCod: resp.data.is_cod,
        isDfod: resp.data.is_dfod,
        listDiscount: resp.data.list_discount,
        recipientName: resp.data.recipient_name,
        stt: resp.data.stt.map(
          (stt: any) =>
            new STT({
              sttRecipientName: stt.stt_recipient_name,
              sttNo: stt.stt_no,
              sttId: stt.stt_id,
              chargeableWeight: stt.chargeable_weight,
              sttDestinationDistrictName: resp.data.destination_district_name,
              productType: stt.product_type,
              totalAfterDiscount: stt.total_after_discount,
              totalBeforeDiscount: stt.total_before_discount
            })
        )
      });
      this.bookingType = "";

      PrintReceiptController.setLastDateSttSuccessBooking(
        new Date().toISOString()
      );
      PrintReceiptController.addListSttSuccessBooking(resp.data.stt[0].stt_no);
      return resp;
    } catch (err) {
      this.handleErrorCreateBooking(err);
    } finally {
      MainAppController.closeLoading();
    }
  }

  get originCountryCode(): string {
    const code =
      LocationController.districtDetail?.countryCode ||
      AccountController.accountData.countryCode;
    return (code || "ID").toUpperCase();
  }

  get isCrossCountryRoute(): boolean {
    return (
      !!this.destinationCity?.id &&
      this.destinationCity?.countryCode !== this.originCountryCode
    );
  }

  get isCrossCountryCod(): boolean {
    return this.isCrossCountryRoute && (this.form.isCOD || this.form.isDFOD);
  }

  get effectiveCurrencyCode(): string {
    if (this.isCrossCountryCod) {
      return getCurrencyCodeByCountry(this.destinationCity.countryCode);
    }
    return "";
  }

  get prefixCurrency() {
    if (this.isCrossCountryCod) {
      return (
        this.form.destinationCountry.currencySymbol
      );
    }

    return "Rp";
  }

  handleErrorCreateBooking(err: any) {
    this.isShowModalFailedBooking = true;
    const messageReason = this.isForeignAccount
      ? err.response?.data.message.id
      : err.response?.data.message.id;
    const validateMessage = messageReason ? messageReason : "";
    this.setModalErrorCreateBooking(err, validateMessage);
  }

  setModalErrorCreateBooking(err: any, validateMessage: string) {
    this.modalFailedBookingData = {
      error: !err.response
        ? ""
        : err.response.status >= 500
        ? "SYSTEM"
        : err.response.data.message.error_type || validateMessage,
      balance: err.response.data.message.balance || 0,
      price: err.response.data.message.price || 0
    };
  }

  async bookPrintThermal() {
    const book = await this.onCreateBooking();
    if (!book) {
      return;
    }
    this.printThermal(book.data.stt[0].stt_id, book.data.stt[0].stt_no);
  }

  async printThermal(sttId: any, sttNo: any) {
    const print = await this.generatePrintData(sttId, sttNo);

    if (print) {
      const accountType = AccountController.accountData.account_type;
      const payload = payloadOfThermalData(
        this.printData(),
        AccountController.accountData.account_type
      ).map((item: ThermalReceiptData) => ({
        ...item,
        isHubToHub: this.printData().isHubToHub,
        sttBookedForName: this.printData().sttBookedForName,
        otherShipperTicketCode: this.printData().otherShipperTicketCode,
        sttIsCodRetail: false, // this is booking client, not retail,
        bookingType: "client"
      }));
      downloadFilePrn(payload, this.$i18n.locale);
      if (
        this.printData().sttProductType.toLowerCase() === "interpack" ||
        this.printData().sttProductType.toLowerCase() === "interpackmaxi"
      ) {
        this.printInterpack(this.printData());
      }
    }
  }

  async bookPrintDoc(type: number, autoPrint = false) {
    const book = await this.onCreateBooking();
    if (!book) {
      return;
    }
    const print = await this.generatePrintData(
      book.data.stt[0].stt_id,
      book.data.stt[0].stt_no
    );
    if (book && print) {
      await this.loadToPdf(type, true, autoPrint);
    }
  }

  async generatePrintData(sttId: any, sttNo: any) {
    return BookingController.getPrintDataByStt(
      new PrintDetailRequest({
        sttNo: sttNo,
        id: sttId,
        accountType:
          AccountController.accountData.account_type === "partner"
            ? AccountController.accountData.account_type_detail.type
            : AccountController.accountData.account_type
      })
    );
  }

  printData(): PrintDataEntitas {
    return BookingController.generatePrintData;
  }

  bookingTypePayload(printData: PrintDataEntitas) {
    let type = "client";
    if (printData.sttReverseJourneyShipmentId.match(/^ARA|^ARB|^AP|^AS/)) {
      type = "manual";
    }
    if (printData.sttShipmentId) {
      type = "shipment";
    }

    if (!printData.sttShipmentId && printData.sttClientId === 0) {
      type = "manual";
    }
    return "client";
  }

  async loadToPdf(
    type: number,
    withInvoice = false,
    autoPrint = false,
    isBookInstan = false
  ) {
    await this.generateReceipt(this.printData(), type, autoPrint, isBookInstan);
    const withInterpack =
      this.printData().sttProductType.toLowerCase() === "interpack" ||
      this.printData().sttProductType.toLowerCase() === "interpackmaxi";
    if (withInterpack && withInvoice) {
      this.printInterpack(this.printData());
    }
  }

  async generateReceipt(
    printData: PrintDataEntitas,
    type = 0,
    autoPrint = false,
    isBookInstan = false
  ) {
    /* barcode */
    const barcode = document.createElement("img");
    JsBarcode(barcode, printData.sttNo, {
      textAlign: "left",
      displayValue: false,
      fontSize: 16
    });

    /* vendor ref code */
    let vendorRefCode: any = "";
    if (printData.sttVendorRefferenceNo) {
      vendorRefCode = document.createElement("img");
      JsBarcode(vendorRefCode, printData.sttVendorRefferenceNo, {
        textAlign: "left",
        displayValue: false,
        fontSize: 16
      });
    }

    if (type === 0) {
      await generateThermalPDFV2(
        "client",
        AccountController.accountData.account_type,
        printData,
        barcode.src,
        vendorRefCode?.src,
        printData.sttElexysNo || printData.sttNo,
        printData.sttVendorRefferenceNo,
        logoBlack,
        printData.sttShipmentId || "",
        true,
        AccountController.accountData.accountIsForeign ? "en" : "id",
        autoPrint,
        isBookInstan
      );
    } else {
      await generatePDFV2(
        "client",
        AccountController.accountData.account_type,
        printData,
        barcode.src,
        vendorRefCode?.src,
        printData.sttElexysNo || printData.sttNo,
        printData.sttVendorRefferenceNo,
        logoBlack,
        printData.sttShipmentId || "",
        true,
        AccountController.accountData.accountIsForeign ? "en" : "id",
      );
    }
  }

  async printInterpack(headerData: PrintDataEntitas, pageSize: "a4" | "a6" = "a4") {
    MainAppController.showLoading();
    try {
      const logo = await import("@/app/ui/assets/images/logo-lion-parcel.png");
      const locales = AccountController.accountData.account_type_detail.countryCode?.toLowerCase();
      generateCommercialInvoiceV2(
        headerData,
        logo.default,
        locales === "my" ? "my" : undefined,
        pageSize
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  _customRound(fractionRule = 0.31, weightNumber = 0) {
    const fraction = weightNumber % 1;

    if (Number(fraction.toFixed(2)) >= fractionRule) {
      return Math.ceil(weightNumber);
    }

    return Math.floor(weightNumber);
  }

  onCloseSuccess() {
    // on close success trigger
  }

  onCloseSuccessBooking() {
    this.isShowModalSuccessBooking = false;
    const commodity = this.form.commodity;
    const tempForm = this.form;
    this.form = new BookingV3({
      sender: tempForm.sender,
      addressSender: tempForm.addressSender,
      phoneSender: tempForm.phoneSender,
      phoneFlagSender: tempForm.phoneFlagSender,
      phoneCodeSender: tempForm.phoneCodeSender,
      phoneCodeReceiver: tempForm.phoneCodeReceiver,
      phoneFlagReceiver: tempForm.phoneFlagReceiver,
      clientName: tempForm.clientName,
      commodity: commodity,
      productName: tempForm.productName
    });
    this.currentIndex = 0;
    this.error = new ErrorBookingV3();
    this.upsellingData = [];
    this.scrollToTop();
    this.showWarningHws = false;
    this.isRebookingFlow = true;
    window.dispatchEvent(new Event("success-booking"));
  }

  scrollToPosition(location: any) {
    if (!location) return;

    document.getElementById(location)?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest"
    });
  }

  scrollToTop() {
    const el = document.getElementById("create-booking-retail-form");
    if (!el) {
      return;
    }
    el.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest"
    });
  }

  goBack() {
    this.$router.push(this.$route.matched[0].path);
  }

  onEnterBooking(event: any) {
    const isOnProcessBooking =
      this.isShowModalSuccessBooking || this.isShowModalFailedBooking;
    if (event.key === "Enter") {
      this.currentIndex = 35;
      if (!this.isFormValid || isOnProcessBooking) {
        return;
      }
      this.onCreateBooking();
    }
  }

  get isAccountPosOrInternal() {
    const account = AccountController.accountData;
    return account.isPosAccount || account.isInternalAccount;
  }

  get isAccountClient() {
    return AccountController.accountData.isAllClient;
  }

  get clientId() {
    return AccountController.accountData.account_id;
  }

  get isDO() {
    return AccountController.accountData.account_type === "client"
      ? AccountController.accountData.account_type_detail.isDO
      : this.form.clientName.isDO;
  }

  get isErrorEmbargoDestination() {
    return (
      this.upsellingData.length > 0 &&
      this.upsellingData.every((item) => item.isEmbargo) &&
      !!this.form.destinationCity
    );
  }

  get isCodAmount() {
    return this.isAccountClient
      ? AccountController.accountData.account_type_detail.codConfigAmount ===
          "goods_price"
      : this.form.clientName?.clientCodConfigAmountData &&
          this.form.clientName?.clientCodConfigAmountData === "goods_price";
  }

  async printPDFOnSuccessBooking(sttId: any, sttNo: any) {
    const print = await this.generatePrintData(sttId, sttNo);
    if (print) {
      await this.loadToPdf(0, true, true);
    }
  }

  get isSidebarAndBreadcrumbV2() {
    return MainAppController.isSidebarAndBreadcrumbV2;
  }

  focusToFilterClient() {
    if (["client"].includes(AccountController.accountData.account_type)) {
      return this.focusToShipmentId();
    }
    const wrapper = document.getElementById("filter-wrapper");
    if (wrapper) {
      const button = wrapper.querySelector("button");
      button?.focus();
    }
  }

  focusToShipmentId() {
    const wrapper = document.getElementById("input_booking_shipment_id");
    if (wrapper) {
      const input = wrapper.querySelector("input");
      input?.focus();
    }
  }

  get isSuccessCreateInvoice() {
    return PrintReceiptController.isSuccessCreateInvoice;
  }
  get successCreateInvoiceData() {
    return PrintReceiptController.successCreateInvoiceData;
  }
  get invoiceDetail() {
    return PrintReceiptController.invoiceDetailData;
  }
  onCloseSuccessCreateInvoice() {
    PrintReceiptController.resetCreateInvoiceFromSuccessBooking();
    PrintReceiptController.setSuccessCreateInvoiceData();
    PrintReceiptController.setInvoiceDetailData();
  }
  async handleDownloadCreateInvoice(option: { key: string }) {
    // Options: 'pdf_a4', 'png_a4', 'struk'
    try {
      MainAppController.showLoading();
      const detail = await PrintReceiptController.getDetailInvoice(
        PrintReceiptController.invoiceDetailData.header.invoiceId
      );
      PrintReceiptController.setInvoiceDetailData(
        new Invoice({
          ...detail,
          header: {
            ...detail.header,
            invoiceId: PrintReceiptController.invoiceDetailData.header.invoiceId
          }
        })
      );
      await nextTick();
      if (option.key === "pdf_a4") {
        await (this.$refs as any).invoice.downloadPdfA4();
      } else if (option.key === "png_a4") {
        await (this.$refs as any).invoice.downloadPngA4();
      } else if (option.key === "struk") {
        await (this.$refs as any).struk.downloadPdfStruk();
      }
    } catch (error) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(error, "Gagal mendapatkan detail invoice!", () => {
          MainAppController.closeErrorMessage();
          this.handleDownloadCreateInvoice(option);
        })
      );
    } finally {
      MainAppController.closeLoading();
    }
    PrintReceiptController.activity({
      id: PrintReceiptController.invoiceDetailData.header.invoiceId,
      payload: new ActivityRequest(true)
    });
  }

  onSelectClient(data: any) {
    this.isSuccessfulCallFromShipment = false;
    this.clientManagementDetail = data;
    this.onResetPaymentMethod();
    ProductController.fetchVolumetricDivisors(data.clientCountry);
    this.getRoundingRulesConfig();
    BookingController.getInsuranceTypesDelivery({
      insuranceConfig: 2,
      originCountry: data.clientCountry
    });
  }

  clearSessionStorage() {
    sessionStorage.removeItem(PRINT_RECEIPT_KEY.LIST_STT_SUCCESS_BOOKING);
    sessionStorage.removeItem(PRINT_RECEIPT_KEY.LAST_DATE_STT_SUCCESS_BOOKING);

    PrintReceiptController.SET_LIST_STT_SUCCESS_BOOKING([]);
    PrintReceiptController.SET_LAST_DATE_STT_SUCCESS_BOOKING("");
  }

  formatWeight(value: string) {
    return formatByCountry(
      parseByCountry(value, {
        country: this.accountCountryCode
      }),
      {
        type: "weight",
        country: this.accountCountryCode
      }
    );
  }

  clientIdFromShipment = 0;
  isSuccessfulCallFromShipment = false;

  async handleGetClientDataFromShipment(clientData: any) {
    if (this.isSuccessfulCallFromShipment) {
      this.clientIdFromShipment = 0;
    }
    await this.$nextTick();
    this.isSuccessfulCallFromShipment = true;
    this.clientIdFromShipment = clientData.clientId;
  }

  handleResetFormShipmentId() {
    this.onUpdateOriginCountryDetail();
    if (this.isSuccessfulCallFromShipment) return;
    this.form.shipmentId = "";
    this.isSuccessfulCallFromShipment = true;
  }

  get flagEnableHandleSelectClientIdFromShipment() {
    return (
      AccountController.accountData.account_type_detail.type === "pos" &&
      FlagsPermissionBooking.permission_generate_client_data_from_shipment_id.isEnabled()
    );
  }

  async getCountryList() {
    await LocationController.getCountryList({
      search: "",
      status: "active",
      page: 1,
      limit: 200
    });
  }

  get countryList(): CountryData[] {
    return LocationController.countryData.countryData || [];
  }

  onUpdateOriginCountryDetail() {
    if (!this.form.clientName.id) return;

    this.form.originCountry = new CountryData(
      this.countryList.find(
        (item) => item.code === this.form.clientName.clientCountry
      )
    );
  }

  onChangePaymentMethod(newValue: string, oldValue: string) {
    const wasCodOrDfod = oldValue === "cod" || oldValue === "dfod";
    const isCodOrDfod = newValue === "cod" || newValue === "dfod";

    if (wasCodOrDfod !== isCodOrDfod) {
      this.form.estimationPrice = "";
      this.form.codAmount = "";
    }
  }

  onResetPaymentMethod() {
    this.getInternationalDocConfig();
    this.form.isCOD = false;
    this.form.isDFOD = false;
    this.form.serviceType = "non-cod";
    this.form.estimationPrice = "";
    this.form.codAmount = "";
  }
}
export default CreateBookingClient;
